//import pkg from "../../../package.json";
import adobeTagManager from '../helpers/adobeTagManager';
const config = {
  vendors: [
    {
      api: new adobeTagManager({
        seedFile: 'https://assets.adobedtm.com/launch-ENf9fd61849bd3488da9d08b1300872e7d-development.min.js',
      }),
    },
  ],
  pageDefaults: () => {
    const timestamp = new Date();
    return {
      timestamp,
      //build: pkg.version,
      siteName: 'React Metrics Example',
    };
  },
  pageViewEvent: 'pageLoad',
};

export default config;



// WEBPACK FOOTER //
// ./src/metrics/metrics.config.js